import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const MiInformationOnline = ({ navigation, route }) => {
    const {
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        ids,
        total
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()


    const { postmionline, loading, } = useFormsStore()
    const formatDateForApi = (date) => {
        if (!date) return null;

        const [month, day, year] = date.split('/');

        if (!month || !day || !year) return null;

        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore.personalData?.entityId,
            essUserKey: intializestore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            driverLicense: values?.driverlicense,
            newEmployee: values?.newemployee,
            noOfDependents: values?.noofdependents,
            additionalAmount: values?.additionalamount ? values?.additionalamount : 0,
            exempt: values?.claimexemption,
            explain1: values?.explain1,
            explain2: values?.explain2,
            sign: signatureDataURL,
            DateHired: formatDateForApi(values?.dateHired)
        }
        const response = await postmionline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MI Withholding Taxation'}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('MiInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}
export default MiInformationOnline
